export default function tabs() {
  const tabWrappers = document.querySelectorAll('.js-tabs');

  tabWrappers.forEach(tabWrapper => {
    const tabs = tabWrapper.querySelectorAll('.tab__item');
    const tabContents = tabWrapper.querySelectorAll('.tab-pane');

    tabs.forEach(tab => {
      tab.addEventListener('click', e => {
        e.preventDefault();

        tabs.forEach(tab => {
          tab.classList.remove('active');
        });

        tab.classList.add('active');

        tabContents.forEach(tabContent => {
          tabContent.classList.remove('active');
        });

        const target = tab.dataset.jsTarget;
        const targetContent = tabWrapper.querySelector(target);

        targetContent.classList.add('active');
      });
    });
  });
}
